import { CommunicationConfig } from '@unboared/react';
import { DEFAULT_SCENE, resolveSocketServer, socketServerToken } from '~/config/global.config';
import { getSessionURL } from '~/config/endpoints.config';

import { UnboaredConsoleApi } from '../api';
import { auditScreenSocketCreation } from './screenSocketAudit';

const host = `${window.location.protocol}//${window.location.host}`;

export const makeUnboaredConfig = (
    clientID: string,
    mode: string,
    language: string,
    socketServer?: string,
    screenID?: string
) => {
    const serverURL = resolveSocketServer(socketServer);
    // Only the Node.js server (v2) answers the resume protocol; on v1 (Python)
    // it must stay disabled or the host freezes on resume (see lib supportsResume).
    const supportsResume = socketServerToken(socketServer) === 'v2';
    // Sonde : chaque création de socket écran est datée et numérotée (diagnostic
    // des reconnexions d'écran — voir l'en-tête de screenSocketAudit.ts).
    auditScreenSocketCreation(clientID, mode);
    const ubAPI = new UnboaredConsoleApi(
        clientID,
        DEFAULT_SCENE,
        'screen',
        serverURL,
        mode,
        language,
        supportsResume,
        screenID
    );
    return {
        name: 'Unboared Console',
        // URL réellement composée par le socket (affichée par ScreenConnectLoader).
        serverURL,
        api: ubAPI.init(),
        initialScene: DEFAULT_SCENE,
        config: CommunicationConfig.getSocketIO(
            'screen',
            serverURL,
            {
                url: getSessionURL(host, '{sessionID}', clientID, language, socketServerToken(socketServer)),
            },
            undefined,
            supportsResume
        ),
    };
};
